<template>
    <div class="schedule-list">
        <div class="related-lecture">
            <div class="title">Full lecture <span>{{ isCourseCount }}</span>Lecture</div>
            <div class="button">
                <img v-if="!isAutoPlay" src="/assets/player/autoplay2.png" width="60" height="21" @click="autoPlay" />
                <img v-else src="/assets/player/autoplay2-active.png" width="60" height="21" @click="autoPlay" />
            </div>
        </div>
        <ul class="related-lecture-list">
            <li class="item-group" v-for="course in courseList">
                <div class="title word_comma_1" v-bind:class="{'selected' : course.course_no === courseNo }" @click="play(course.course_no)">{{ course.course_name }}</div>
                <div class="time"><img src="/assets/preview/clock-gray.png" width="11" height="11">{{ course.course_time }}</div>
                <div class="count"><img src="/assets/preview/view-gray.png" width="12" height="8">{{ course.view_count }}</div>
            </li>
        </ul>
    </div>
</template>

<script>
    import * as ajax from "../../utils/ajax";
    import * as utils from "../../utils/utils";
    import * as biz from '../../utils/biz'

    export default {
        name: 'ScheduleList',
        props: {
            courseNo: Number,
            courseList: Array
        },
        data() {
            return {
                isAutoPlay: false,
                courseNumber: 0
            }
        },
        mounted() {
            this.getCourseNumber();
        },
        methods: {
            autoPlay() {
                this.isAutoPlay = !this.isAutoPlay;
                const params = {
                    courseNumber: this.courseNumber,
                    courseList: this.courseList,
                    isAutoPlay: this.isAutoPlay
                };
                switch(utils.deviceInfo()) {
                    case "Android":
                        window.listenApp.isAutoPlayWithSchedule(JSON.stringify(params));
                        break;
                    case "iOS":
                        window.webkit.messageHandlers.isAutoPlayWithSchedule.postMessage(params);
                        break;
                }
            },
            play(course_no) {
                biz.playScheduleAudioPlayer(course_no, this.courseList);
                // 재생 시 화면 맨 우에로
                document.querySelector('div.basic-player').scrollTop = 0;
            },
            playEnded() {
                let nextCourseNo = false;
                const courseNumber = this.courseNumber + 1;

                // 전체강좌재생이 활성화 되여 있는 경우에는 다음강의 재생
                if (this.isAutoPlay) {
                    if(this.courseList[courseNumber] !== undefined) {
                        this.courseNumber = courseNumber;
                        nextCourseNo = this.courseList[courseNumber].course_no;
                        biz.playScheduleAudioPlayer(nextCourseNo, this.courseList);
                    }
                }
            },
            getCourseNumber() {
                for (let item in this.courseList) {
                    if (this.courseList[item].course_no === this.courseNo) {
                        this.courseNumber = Number(item);
                    }
                }
            }
        },
        computed: {
            isCourseCount() {
                return this.courseList.length;
            },
        },
        watch: {
            'courseNo': function(val, oldVal) {
                this.getCourseNumber();
            }
        },
        filters: {
            minuteToStringFormat(value) {
                return utils.minuteToStringFormat(value);
            },
            thousandSeparator(value) {
                return utils.thousandSeparator(value);
            },
            convertSchoolGrade(value) {
                return utils.convertSchoolGrade(value);
            }
        },
    }
</script>

<style scoped lang="scss">
    div.schedule-list {
        padding: 24px 0;

        div.related-lecture {
            margin: 0 auto;
            display: flex;
          padding: 0 $default-margin-right;

            div.title {
                flex: 1;
                font-size: $font-base14;
                font-weight: $font-weight500;

                span {
                    color: $primary-color;
                }
            }

            div.button {
                width: 125px;
                display: flex;
                justify-content: flex-end;

                img:first-child {
                    margin: 0 5px 0 0;
                }
            }
        }

        ul.related-lecture-list {
            list-style: none;
            padding: 0;
            margin: 16px 0;
            font-size: $font-base14;

            li.item-group {
              padding: 0 $default-margin-right;
              border-top: solid 1px $line-secondary-color;
              display: flex;
              justify-content: space-between;
              align-items: center;
              height: 4em;

                div.title {
                    flex: 1;
                    margin: 0 5px 0 0;
                    font-weight: $font-weight500;
                }
                div.title.selected {
                    color: $primary-color;
                }
                div.time {
                    width: 55px;
                    margin: 0 5px 0 0;
                    font-size: $font-base12;

                    img {
                        margin: 0 5px 0 0;
                    }
                }
                div.count {
                    width: 40px;
                    font-size: $font-base12;

                    img {
                        margin: 0 5px 0 0;
                    }
                }
                div.isTrack {
                    width: 12px;
                }

            }
        }

        div.related-lecture-button {
            margin: 20px 0;
            text-align: center;
            font-size: $font-base14;
            color: #5b5a5a;
            padding-top: 13px;
            border-top: 1px solid #ececec;

            ion-icon {
                margin-left: 8px;
            }
        }
    }
</style>
